import { Language } from "./types";

const translations = {
  SV: {
    recipientLanguage: "Språk för mottagarna",
    optionalMessage: "Meddelande (valfritt)",
    noRecipients: "Inga mottagare tillagda.",
    parallelHelp: "Alla får inbjudan samtidigt.",
    sequentialHelp: "Mottagarna signerar i listans ordning. Dra mottagarna för att ändra ordningen.",
    reviewPdfBeforeSending: "Granska PDF-filen och markera att du har granskat den.",
    readyToSend: "Redo att skicka till mottagarna.",
    recoveryNeedsCheck:
      "Signeringen har skapats, men resultatet av det senaste steget kunde inte bekräftas. Kontrollera status eller fortsätt i Krebit Sign.",
    fitColumns: "Anpassa alla kolumner till en sida",
    fitColumnsHelp: "Alla kolumner får plats på bredden. Raderna kan fortsätta på flera sidor.",
    fitOnePageHelp: "Varje blad förminskas till en sida. Stora blad kan bli svåra att läsa.",
    preserveLayoutHelp: "Behåller utskriftsområde, orientering och skalning från Excel.",
    excelRestoreFailure:
      "Excel-inställningarna kunde inte återställas helt. Vissa blad kan fortfarande vara dolda eller ha ändrad skalning. Behåll tillägget öppet och försök återställa igen. Berörda blad:",
    restoreExcel: "Återställ Excel-inställningar",
    excelRestored: "Excel-inställningarna har återställts. Du kan skapa PDF-filen igen.",
    excelScopeUnsupported:
      "Den här Excel-versionen stöder inte export av enbart det aktiva bladet. Välj hela arbetsboken eller uppdatera Excel.",
    excelLayoutUnsupported:
      "Den här Excel-versionen stöder inte ändrad PDF-skalning. Använd Excels utskriftsinställningar eller uppdatera Excel.",
    excelStructureProtected:
      "Arbetsbokens struktur är skyddad, så övriga blad kan inte döljas för export. Välj hela arbetsboken eller ta bort strukturskyddet i Excel.",
    excelTargetUnavailable: "Det valda bladet har dolts eller tagits bort. Välj blad igen och uppdatera PDF-filen.",
    excelContextUnavailable: "Bladinformationen kunde inte hämtas. Försök uppdatera den.",
    refreshSheets: "Uppdatera bladinformation",
    visibleSheets: "synliga blad",
    pdfAttachment: "PDF att skicka",
    preparePdf: "Skapa PDF",
    updatePdf: "Uppdatera PDF",
    pdfNotPrepared: "Skapa och granska PDF-filen innan du skickar.",
    pdfSnapshotHelp:
      "Det är den här PDF-filen som skickas. Har du ändrat Office-filen? Uppdatera PDF-filen före nästa granskning.",
    pdfReviewed: "Jag har granskat PDF-filen",
    pdfReviewRequired: "Skapa och granska PDF-filen innan du skickar signeringen.",
    pdfPopupBlocked:
      "Förhandsgranskningen kunde inte öppnas. Tillåt popup-fönster och försök igen, eller ladda ner PDF-filen.",
    downloadPdf: "Ladda ner PDF",
    pdfReady: "PDF skapad",
    pdfChanged: "Exportvalet eller innehållet har ändrats. Skapa och granska en ny PDF.",
    recoveryTitle: "Slutför den påbörjade signeringen",
    recoveryHelp: "Ett försök har redan påbörjats. Kontrollera signeringen i Krebit Sign innan du skapar en ny.",
    recoveryUnknown:
      "Vi kunde inte bekräfta om signeringen skapades. Kontrollera namnet i Krebit Sign för att undvika en dubblett.",
    openKrebit: "Öppna Krebit Sign",
    checkSigningStatus: "Kontrollera status",
    checkingSigningStatus: "Kontrollerar signeringens status...",
    retrySend: "Försök skicka igen",
    recoveryDraft: "Signeringen är fortfarande ett utkast. Slutför den i Krebit Sign.",
    recoveryReady:
      "Signeringen är fortfarande ett utkast med uppladdad PDF och tillagda mottagare. Du kan försöka skicka samma signering igen.",
    recoveryCancelled: "Signeringen har avbrutits i Krebit Sign.",
    recoveryStatusUnknown:
      "Statusen kunde inte bekräftas. Kontrollera signeringen i Krebit Sign innan du försöker igen.",
    newAfterRecovery: "Jag har kontrollerat – börja på en ny",
    recoveryStorageFailure:
      "Återställningsinformationen kunde inte sparas. Tillåt lokal lagring i tillägget innan du skickar.",
    addMe: "Lägg till mig",
    addRecipient: "Lägg till mottagare",
    addRecipientBeforeSending: "Lägg till minst en mottagare innan du skickar.",
    activeWorksheet: "Aktivt kalkylblad",
    addingDocument: "Lägger till filen...",
    addingRecipient: "Lägger till mottagare",
    allow: "Tillåt",
    approval: "Godkännande",
    approvers: "Godkännare",
    alreadyHaveAccount: "Har din organisation redan Krebit Sign?",
    authentication: "Inloggning",
    authUnavailable: "Det går inte att logga in just nu. Kontakta Krebit Sign-support.",
    backToSigning: "Tillbaka till signering",
    bookDemo: "Boka demo",
    cancel: "Avbryt",
    cannotCompleteSignIn: "Det gick inte att slutföra inloggningen. Försök igen.",
    cannotOpenAuth: "Det gick inte att öppna inloggningsfönstret.",
    checkingSignIn: "Kontrollerar din inloggning...",
    checkingWorkspace: "Kontrollerar arbetsytan...",
    chooseLanguage: "Välj svenska eller engelska som språk.",
    chooseOrder: "Välj en giltig signeringsordning.",
    contactKrebit: "Kontakta Krebit",
    creatingSigning: "Skapar signeringen...",
    currentDocument: "Aktuell fil",
    defaultLanguageSaved: "Standardspråk sparat: ",
    dialogClosed: "Inloggningsfönstret stängdes innan inloggningen var klar.",
    discardChanges: "Lämna utan att spara",
    document: "Fil",
    documentTooLarge: "Filen är större än 10 MB. Minska filstorleken och försök igen.",
    domain: "Domän",
    email: "E-post",
    emailAddress: "E-postadress",
    emailMissing: "E-post saknas",
    english: "Engelska",
    entireWorkbook: "Hela arbetsboken",
    enterSigningName: "Ange ett namn för signeringen.",
    excelExport: "Excel-export",
    excelExportSettingsFailure:
      "Det gick inte att tillämpa Excel-exportinställningarna. Kontrollera arbetsboken och försök igen.",
    exportContent: "Innehåll",
    firstName: "Förnamn",
    firstRunPdfExport:
      "Krebit Sign gör om Office-filen till PDF och hjälper dig att skicka avtal, offerter, orderformulär och godkännanden för elektronisk signering.",
    firstRunValue: "Skicka Word-dokument och Excel-filer för signering direkt från Microsoft 365.",
    fitOnePage: "Anpassa varje blad till en sida",
    genericError: "Något gick fel. Försök igen.",
    ignore: "Ignorera",
    invalidSubdomain: "Ange en giltig subdomän för organisationen.",
    language: "Språk",
    lastName: "Efternamn",
    loggedIn: "Inloggad",
    loggedInAs: "Inloggad som",
    loginBeforeCreate: "Logga in innan du skapar en signering.",
    krebitSignMicrosoft365: "Krebit Sign for Microsoft 365",
    message: "Meddelande",
    name: "Namn",
    needAccount: "Behöver du ett konto?",
    needAccountText:
      "Krebit Sign används av organisationer. Konton hanteras vanligtvis av ditt företag. Om ni inte har tillgång ännu kan du boka en demo med Krebit AB.",
    newRecipient: "Ny mottagare",
    newSigning: "Ny signering",
    noDomainSelected: "Ingen domän vald",
    notSignedIn: "Inte inloggad",
    of: "av",
    openingAuthentication: "Öppnar säker inloggning...",
    organizationSubdomain: "Organisationens subdomän",
    pageLayout: "Sidlayout",
    parallel: "Parallellt",
    partialSigningFailure:
      " Signeringen skapades, men alla steg kunde inte slutföras. Du kan slutföra den i Krebit Sign.",
    previewPdf: "Förhandsgranska PDF",
    preservePageLayout: "Använd Excels utskriftsinställningar",
    popupText: "Fönstret används för säker inloggning i Krebit Sign.",
    popupTitle: "Krebit Sign vill öppna ett nytt fönster.",
    preparingDocument: "Förbereder filen...",
    prepareDocumentFailure: "Det gick inte att förbereda Office-filen för signering.",
    ready: "Redo",
    recipientRequired: "Varje mottagare behöver förnamn, efternamn, giltig e-postadress och signeringsmetod.",
    recipients: "Mottagare",
    removeRecipient: "Ta bort mottagare",
    recipientDiscardQuestion: "Lämna utan att spara?",
    recipientDiscardText: "Ändringarna för mottagaren sparas inte.",
    reset: "Nollställ",
    resetQuestion: "Nollställ signeringen?",
    resetSigning: "Nollställ signering",
    resetText: "All information du har angett för signeringen och mottagarna tas bort.",
    save: "Spara",
    change: "Ändra",
    saveRecipientReturn: "Spara och återgå",
    saveSubdomainFirst: "Spara först en giltig subdomän för organisationen.",
    send: "Skicka",
    sendingSigning: "Skickar signeringen...",
    sequential: "Sekventiellt",
    settings: "Inställningar",
    signers: "Signerare",
    signing: "Signering",
    signingDescription: "Office-filen exporteras till PDF och skickas via Krebit Sign.",
    signingMethod: "Signeringsmetod",
    signingOrder: "Signeringsordning",
    signingSent: "Signering skickad",
    signingSentText: "Signeringen har skickats till mottagarna.",
    signIn: "Logga in",
    signInAttemptExpired: "Inloggningsförsöket har gått ut. Starta inloggningen igen.",
    signInAttemptMissing: "Inloggningsförsöket kunde inte hittas. Börja om.",
    signInAttemptUnverified: "Inloggningsförsöket kunde inte verifieras. Börja om.",
    signedInToKrebit: "Inloggad i Krebit Sign.",
    signInExpired: "Din inloggning har gått ut. Logga in igen för att fortsätta.",
    signOut: "Logga ut",
    signedOut: "Utloggad.",
    swedish: "Svenska",
    using: "Använder ",
    viewsLabel: "Vyer i Krebit Sign",
    workspace: "Arbetsyta",
    workspaceContinuePrompt: "Ange organisationens Krebit Sign-adress för att fortsätta.",
    workspaceExample: "Exempel: ditt-bolag.krebit.se",
    workspaceNotFoundText:
      "Vi hittar ingen Krebit Sign-arbetsyta med den här adressen. Kontrollera stavningen eller kontakta din administratör.",
    workspaceNotFoundTitle: "Vi hittar inte arbetsytan.",
    workspacePlaceholder: "ditt-bolag",
    workspaceSubdomain: "Organisationens Krebit Sign-adress",
  },
  EN: {
    recipientLanguage: "Recipient language",
    optionalMessage: "Message (optional)",
    noRecipients: "No recipients added.",
    parallelHelp: "Everyone receives the invitation at the same time.",
    sequentialHelp: "Recipients sign in the order listed. Drag recipients to change the order.",
    reviewPdfBeforeSending: "Review the PDF and mark it as reviewed.",
    readyToSend: "Ready to send to the recipients.",
    recoveryNeedsCheck:
      "The signing was created, but the result of the last step could not be confirmed. Check its status or continue in Krebit Sign.",
    fitColumns: "Fit all columns on one page",
    fitColumnsHelp: "All columns fit across the page. Rows can continue on additional pages.",
    fitOnePageHelp: "Each sheet fits on one page. Large sheets may become difficult to read.",
    preserveLayoutHelp: "Keeps Excel’s print area, orientation and scaling.",
    excelRestoreFailure:
      "Excel settings could not be fully restored. Some sheets may still be hidden or have changed scaling. Keep the add-in open and retry restoration. Affected sheets:",
    restoreExcel: "Restore Excel settings",
    excelRestored: "Excel settings have been restored. You can create the PDF again.",
    excelScopeUnsupported:
      "This Excel version cannot export only the active sheet. Choose the entire workbook or update Excel.",
    excelLayoutUnsupported: "This Excel version cannot change PDF scaling. Use Excel’s print settings or update Excel.",
    excelStructureProtected:
      "The workbook structure is protected, so other sheets cannot be hidden for export. Choose the entire workbook or remove structure protection in Excel.",
    excelTargetUnavailable: "The selected sheet was hidden or removed. Select a sheet again and update the PDF.",
    excelContextUnavailable: "Sheet information could not be loaded. Try refreshing it.",
    refreshSheets: "Refresh sheet information",
    visibleSheets: "visible sheets",
    pdfAttachment: "PDF to send",
    preparePdf: "Create PDF",
    updatePdf: "Update PDF",
    pdfNotPrepared: "Create and review the PDF before sending.",
    pdfSnapshotHelp:
      "This is the PDF that will be sent. Edited the Office file? Update the PDF before reviewing it again.",
    pdfReviewed: "I have reviewed the PDF",
    pdfReviewRequired: "Create and review the PDF before sending the signing.",
    pdfPopupBlocked: "The preview could not be opened. Allow pop-ups and try again, or download the PDF.",
    downloadPdf: "Download PDF",
    pdfReady: "PDF created",
    pdfChanged: "The export selection or content changed. Create and review a new PDF.",
    recoveryTitle: "Finish the existing signing",
    recoveryHelp: "An attempt has already started. Check the signing in Krebit Sign before creating another.",
    recoveryUnknown:
      "We could not confirm whether the signing was created. Check its name in Krebit Sign to avoid a duplicate.",
    openKrebit: "Open Krebit Sign",
    checkSigningStatus: "Check status",
    checkingSigningStatus: "Checking signing status...",
    retrySend: "Retry sending",
    recoveryDraft: "The signing is still a draft. Finish it in Krebit Sign.",
    recoveryReady:
      "The signing is still a draft with its PDF uploaded and recipients added. You can retry sending the same signing.",
    recoveryCancelled: "The signing has been cancelled in Krebit Sign.",
    recoveryStatusUnknown: "The status could not be confirmed. Check the signing in Krebit Sign before trying again.",
    newAfterRecovery: "I have checked — start a new signing",
    recoveryStorageFailure: "Recovery details could not be saved. Allow local storage in the add-in before sending.",
    addMe: "Add me",
    addRecipient: "Add recipient",
    addRecipientBeforeSending: "Add at least one recipient before sending.",
    activeWorksheet: "Active worksheet",
    addingDocument: "Adding the file...",
    addingRecipient: "Adding recipient",
    allow: "Allow",
    approval: "Approval",
    approvers: "Approvers",
    alreadyHaveAccount: "Does your organization already use Krebit Sign?",
    authentication: "Sign-in",
    authUnavailable: "Sign-in is not available right now. Contact Krebit Sign support.",
    backToSigning: "Back to signing",
    bookDemo: "Book a demo",
    cancel: "Cancel",
    cannotCompleteSignIn: "We could not complete sign-in. Please try again.",
    cannotOpenAuth: "We could not open the sign-in window.",
    checkingSignIn: "Checking your sign-in...",
    checkingWorkspace: "Checking the workspace...",
    chooseLanguage: "Choose Swedish or English as the language.",
    chooseOrder: "Choose a valid signing order.",
    contactKrebit: "Contact Krebit",
    creatingSigning: "Creating the signing...",
    currentDocument: "Current file",
    defaultLanguageSaved: "Default language saved: ",
    dialogClosed: "The sign-in window closed before sign-in was completed.",
    discardChanges: "Leave without saving",
    document: "File",
    documentTooLarge: "This file is larger than 10 MB. Reduce the file size and try again.",
    domain: "Domain",
    email: "Email",
    emailAddress: "Email address",
    emailMissing: "Email missing",
    english: "English",
    entireWorkbook: "Entire workbook",
    enterSigningName: "Enter a signing name.",
    excelExport: "Excel export",
    excelExportSettingsFailure: "We couldn't apply the Excel export settings. Check the workbook and try again.",
    exportContent: "Content",
    firstName: "First name",
    firstRunPdfExport:
      "Krebit Sign converts your Office file to PDF and helps you send agreements, quotes, order forms, and approvals for electronic signing.",
    firstRunValue: "Send Word documents and Excel files for signing directly from Microsoft 365.",
    fitOnePage: "Fit each sheet to one page",
    genericError: "Something went wrong. Please try again.",
    ignore: "Ignore",
    invalidSubdomain: "Enter a valid organization subdomain.",
    language: "Language",
    lastName: "Last name",
    loggedIn: "Signed in",
    loggedInAs: "Signed in as",
    loginBeforeCreate: "Sign in before creating a signing.",
    krebitSignMicrosoft365: "Krebit Sign for Microsoft 365",
    message: "Message",
    name: "Name",
    needAccount: "Need an account?",
    needAccountText:
      "Krebit Sign is designed for organizations. Accounts are usually managed by your company. If your organization does not have access yet, you can book a demo with Krebit AB.",
    newRecipient: "New recipient",
    newSigning: "New signing",
    noDomainSelected: "No domain selected",
    notSignedIn: "Not signed in",
    of: "of",
    openingAuthentication: "Opening secure sign-in...",
    organizationSubdomain: "Organization subdomain",
    pageLayout: "Page layout",
    parallel: "Parallel",
    partialSigningFailure:
      " The signing was created, but not all steps were completed. You can finish it in Krebit Sign.",
    previewPdf: "Preview PDF",
    preservePageLayout: "Use Excel's print settings",
    popupText: "This window is used for secure sign-in to Krebit Sign.",
    popupTitle: "Krebit Sign wants to open a new window.",
    preparingDocument: "Preparing the file...",
    prepareDocumentFailure: "We could not prepare this Office file for signing.",
    ready: "Ready",
    recipientRequired: "Each recipient needs a first name, last name, valid email address, and signing method.",
    recipients: "Recipients",
    removeRecipient: "Remove recipient",
    recipientDiscardQuestion: "Leave without saving?",
    recipientDiscardText: "Your changes to the recipient will not be saved.",
    reset: "Reset",
    resetQuestion: "Reset signing?",
    resetSigning: "Reset signing",
    resetText: "All information entered for the signing and its recipients will be removed.",
    save: "Save",
    change: "Change",
    saveRecipientReturn: "Save and return",
    saveSubdomainFirst: "Save a valid organization subdomain first.",
    send: "Send",
    sendingSigning: "Sending the signing...",
    sequential: "Sequential",
    settings: "Settings",
    signers: "Signers",
    signing: "Signing",
    signingDescription: "The Office file is exported as a PDF and sent through Krebit Sign.",
    signingMethod: "Signing method",
    signingOrder: "Signing order",
    signingSent: "Signing sent",
    signingSentText: "The signing has been sent to the recipients.",
    signIn: "Sign in",
    signInAttemptExpired: "The sign-in attempt expired. Start sign-in again.",
    signInAttemptMissing: "Your sign-in attempt could not be found. Please start again.",
    signInAttemptUnverified: "We could not verify this sign-in attempt. Please start again.",
    signedInToKrebit: "Signed in to Krebit Sign.",
    signInExpired: "Your sign-in has expired. Sign in again to continue.",
    signOut: "Sign out",
    signedOut: "Signed out.",
    swedish: "Swedish",
    using: "Using ",
    viewsLabel: "Krebit Sign views",
    workspace: "Workspace",
    workspaceContinuePrompt: "Enter your organization's Krebit Sign address to continue.",
    workspaceExample: "Example: your-company.krebit.se",
    workspaceNotFoundText:
      "We could not find a Krebit Sign workspace with this address. Check the spelling or contact your administrator.",
    workspaceNotFoundTitle: "We could not find the workspace.",
    workspacePlaceholder: "your-company",
    workspaceSubdomain: "Organization's Krebit Sign address",
  },
} as const;

export type TranslationKey = keyof (typeof translations)["SV"];

let currentLanguage: Language = "EN";

export function setUiLanguage(language: Language): void {
  currentLanguage = language;
}

export function t(key: TranslationKey): string {
  return translations[currentLanguage][key];
}
